// 颜色配置

// 规划用地颜色
export const colorMap = {
  学校: "#ec0bf4",
  金融: "#ef1010",
  工业: "#ff7800",
  住宅: "#fdfa04",
  绿化: "#24f808",
  公用: "#0656f9",
  村镇: "#08f8ea",
}

// 配套设施颜色
export const colorPtMap = [
  {
    txt: "交通",
    color: "#ff8a25",
  },
  {
    txt: "学校",
    color: "#0087f9",
  },
  {
    txt: "商场",
    color: "#6d27f6",
  },
  {
    txt: "医院",
    color: "#00d1fc",
  },
  {
    txt: "景观",
    color: "#00fd3f",
  },
  {
    txt: "文化",
    color: "#ff06b7",
  },
]

// 新盘分布颜色
export const colorNEMap = [
  {
    txt: "新房楼盘",
    color: "#ff000e",
  },
  {
    txt: "二手房楼盘",
    color: "#002af6",
  },
]

// 规控用地颜色
export const colorKgMap = [
  {
    txt: "商业商务",
    color: "#fe0000CC",
  },
  {
    txt: "住宅",
    color: "#fdfe00CC",
  },
  {
    txt: "教育科研",
    color: "#fe64e0CC",
  },
  {
    txt: "医疗",
    color: "#fe7b83CC",
  },
  {
    txt: "行政文体",
    color: "#dd32d9CC",
  },
  {
    txt: "交通",
    color: "#8f8f8fCC",
  },
  {
    txt: "工业",
    color: "#de8a70CC",
  },
  {
    txt: "绿地",
    color: "#00ff01CC",
  },
  {
    txt: "水域",
    color: "#7ecdf4CC",
  },
]

export default {
  colorMap,
  colorPtMap,
  colorNEMap,
  colorKgMap
}



// WEBPACK FOOTER //
// ./src/page/makeLocationImage/config/colorConfig.js